import React, { useEffect, useState } from "react";
import { Cross } from "../assets/icons";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import dayjs from "dayjs";
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Dialog,
  Chip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Styles from "../../styles/vendorDashboard.module.css";

// import FormatTimestamp from "./FormatTimestamp"; // Adjust as necessary

const columns = [
  {
    field: "serial",
    headerName: "NO. ",
    width: 20,
  },
  { field: "campaign", headerName: "CAMPAIGN", width: 40 },
  { field: "clusterId", headerName: "CLUSTER ID", width: 60 },
  { field: "KAM", headerName: "KAM", width: 120 },
  // { field: "delivery", headerName: "DELIVERY ADDRESS", width: 160 },
  { field: "jobTimeline", headerName: "JOB TIMELINE", width: 190 },
  { field: "buget", headerName: "BUDGET", width: 80 },
  { field: "advanceAmount", headerName: "ADVANCE AMOUNT", width: 80 },
  { field: "balanceAmount", headerName: "BALANCE AMOUNT ", width: 80 },
  // { field: "pdiStatus", headerName: "PDI STATUS", width: 70 },
  { field: "paymentStatus", headerName: "PAYMENT STATUS", width: 70 },
  // { field: "action", headerName: "ACTION", width: 60 },
];

const data = [
  {
    no: 1,
    campagin: "Campaign Name 2024",
    jobId: "#12345",
    KAM: "Neeraj Singh",
    DeliveryAddress: "Ramseh Store Name, Plot no.1, Sector 7/D FBD| HR",
    jobTimeLine: "10 OCT 24 - 24 DEC 24 ",
    buget: "100000",
    advanceAmount: " 300000",
    balance: " 70000",
    pdiStatus: "Pending",
    paymentStatus: "Pending",
  },
  {
    no: 2,
    campagin: "Campaign Name 2024",
    jobId: "#12345",
    KAM: "Neeraj Singh",
    DeliveryAddress: "Ramseh Store Name",
    jobTimeLine: "10 OCT 24 - 24 DEC 24 ",
    buget: "100000",
    advanceAmount: "300000",
    balance: " 70000",
    pdiStatus: "Pending",
    paymentStatus: "Pending",
  },
  {
    no: 3,
    campagin: "Campaign Name 2024",
    jobId: "#12345",
    KAM: "Neeraj Singh",
    DeliveryAddress: "Ramseh Store Name",
    jobTimeLine: "10 OCT 24 - 24 DEC 24 ",
    buget: "100000",
    advanceAmount: "300000",
    balance: "70000",
    pdiStatus: "Done",
    paymentStatus: "Paid",
  },
  {
    no: 4,
    campagin: "Campaign Name 2024",
    jobId: "#12345",
    KAM: "Neeraj Singh",
    DeliveryAddress: "Ramseh Store Name",
    jobTimeLine: "10 OCT 24 - 24 DEC 24 ",
    buget: "100000",
    advanceAmount: " 300000",
    balance: "70000",
    pdiStatus: "Pending",
    paymentStatus: "Pending",
  },
  {
    no: 4,
    campagin: "Campaign Name 2024",
    jobId: "#12345",
    KAM: "Neeraj Singh",
    DeliveryAddress: "Ramseh Store Name",
    jobTimeLine: "10 OCT 24 - 24 DEC 24 ",
    buget: "100000",
    advanceAmount: " 300000",
    balance: "70000",
    pdiStatus: "Pending",
    paymentStatus: "Pending",
  },
  {
    no: 4,
    campagin: "Campaign Name 2024",
    jobId: "#12345",
    KAM: "Neeraj Singh",
    DeliveryAddress: "Ramseh Store Name",
    jobTimeLine: "10 OCT 24 - 24 DEC 24 ",
    buget: "100000",
    advanceAmount: " 300000",
    balance: "70000",
    pdiStatus: "Pending",
    paymentStatus: "Pending",
  },
  {
    no: 4,
    campagin: "Campaign Name 2024",
    jobId: "#12345",
    KAM: "Neeraj Singh",
    DeliveryAddress: "Ramseh Store Name",
    jobTimeLine: "10 OCT 24 - 24 DEC 24 ",
    buget: "100000",
    advanceAmount: " 300000",
    balance: "70000",
    pdiStatus: "Pending",
    paymentStatus: "Pending",
  },
  {
    no: 4,
    campagin: "Campaign Name 2024",
    jobId: "#12345",
    KAM: "Neeraj Singh",
    DeliveryAddress: "Ramseh Store Name",
    jobTimeLine: "10 OCT 24 - 24 DEC 24 ",
    buget: "100000",
    advanceAmount: " 300000",
    balance: "70000",
    pdiStatus: "Pending",
    paymentStatus: "Pending",
  },
];

const VendorPaymentsModal = ({
  isVendorPaymentModalOpen,
  setIsVendorPaymentModalOpen,
  selectedVendorData,
}) => {
  const [allDetails, setAllDetails] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isActionLoading, setIsActionLoading] = useState(false);

  useEffect(() => {
    setAllDetails(data);
  }, []);
  const handleClick = () => {};

  const handleClose = () => {
    setIsVendorPaymentModalOpen(false);
  };

  return (
    <Dialog open={isVendorPaymentModalOpen} fullScreen fullWidth>
      <div className=" px-16 md:px-24 py-5 relative">
        <div className="flex justify-between gap-3 mt-5">
          <div>
            <div className="flex justify-start items-center  gap-2">
              <h1 className="tex-[20px] font-bold  ">
                {selectedVendorData.vendorDetails.vendorBusinessName &&
                  selectedVendorData.vendorDetails.vendorBusinessName
                    .charAt(0)
                    .toUpperCase() +
                    selectedVendorData.vendorDetails.vendorBusinessName.slice(
                      1
                    )}
              </h1>
              <Chip
                label={selectedVendorData?.vendorDetails.status || "N/A"}
                color={
                  selectedVendorData?.vendorDetails.status === "Active"
                    ? "success"
                    : selectedVendorData?.vendorDetails.status === "Inactive"
                    ? "primary" // or any other color for inactive
                    : selectedVendorData?.vendorDetails.status === "Blacklisted"
                    ? "error"
                    : "default"
                }
              />
            </div>

            <p>{selectedVendorData.vendorDetails.ownerName}</p>
            <p className="flex items-center justify-start">
              {selectedVendorData.vendorDetails.address},{" "}
              {selectedVendorData.vendorDetails.city},{" "}
              {selectedVendorData.vendorDetails.state},{" "}
              {selectedVendorData.vendorDetails.pinCode}
            </p>
            <p></p>
            <p className="flex items-center justify-start">
              {selectedVendorData.vendorDetails.ownerPrimaryContactNo && (
                <p>{selectedVendorData.vendorDetails.ownerPrimaryContactNo}</p>
              )}
            </p>
            <p className="font-semibold text-[var(--heading-color)]">
              GSTIN: {selectedVendorData.vendorDetails.GSTIN}
            </p>
          </div>

          <div>
            <div
              onClick={handleClose}
              className="mx-5 my-4 flex justify-end absolute right-1 top-1"
              style={{ cursor: "pointer" }}
            >
              <Cross />
            </div>
            <p>
              Total Campaigns :{" "}
              <span className="text-[var(--heading-color)]">
                {" "}
                {selectedVendorData?.overAllcampaignData?.totalCampaigns || "0"}
              </span>
            </p>
            <p>
              Pending Campaigns :{" "}
              <span className="text-[var(--heading-color)]">
                {" "}
                {selectedVendorData?.overAllcampaignData?.pendingCampaigns ||
                  "0"}
              </span>
            </p>
            <p>
              Total Earned :{" "}
              {
                <CurrencyRupeeIcon
                  style={{
                    fontSize: "12px",
                    marginBottom: 2,
                    color: "var(--heading-color)",
                  }}
                />
              }
              <span className="text-[var(--heading-color)]">
                {" "}
                {selectedVendorData?.overAllcampaignData?.totalEarned || "0"}
              </span>
            </p>
          </div>
        </div>
      </div>

      <Grid>
        <>
          <TableContainer
            sx={{
              height: "calc(85vh - 97px)",
              maxHeight: "calc(85vh - 97px)",
              maxWidth: "calc(88vw - 0px)",
              width: "calc(88vw - 0px)",

              overflowY: "auto",
            }}
            className={`mt-2  border rounded-xl mx-auto ${Styles["custom-scrollbar"]}`}
          >
            <Table
              stickyHeader
              aria-label="customized table"
              className="rounded-lg"
            >
              <TableHead>
                <TableRow>
                  {columns?.map((column, index) => (
                    <TableCell
                      key={column.field}
                      sx={{
                        minWidth: column.width,
                        // backgroundColor: "var(--light-primary-color)",
                        fontWeight: "bold",
                        // height: 90,
                        // borderRight:
                        //   index < columns.length - 1
                        //     ? "1px solid #ccc"
                        //     : "none",
                      }}
                    >
                      <span className="text-[12px]">{column.headerName}</span>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedVendorData?.campaigns &&
                selectedVendorData?.campaigns?.length > 0 ? (
                  selectedVendorData?.campaigns.map((row, i) => {
                    // const isRowSelected = selected.includes(row.id);
                    return (
                      <TableRow
                        key={i}
                        hover
                        // selected={isRowSelected}
                        sx={{
                          // borderRight: "1px solid #ccc",
                          cursor: "pointer",
                        }}
                      >
                        <TableCell>{i + 1}</TableCell>
                        <TableCell
                        // sx={{
                        //   borderRight: "1px solid #ccc",
                        //   padding: "4px 8px",
                        // }}
                        >
                          <p className="text-[12px]"> {row?.campaignTitle} </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            {" "}
                            {row?.cluster?._id.slice(-6)}{" "}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            {" "}
                            {row.keyAccountManagerName || "N/A"}{" "}
                          </p>
                        </TableCell>
                        {/* <TableCell>
                          <p className="text-[12px]">
                            {row.DeliveryAddress ? (
                              <>
                                {row.DeliveryAddress.split(",")[0]}{" "}
                                <br />
                                <span className="text-[9px]">
                                  {row.DeliveryAddress.split(",")
                                    .slice(1)
                                    .join(", ")}{" "}
                                </span>
                              </>
                            ) : (
                              "N/A"
                            )}
                          </p>
                        </TableCell> */}
                        <TableCell>
                          <p className="text-[12px]">
                            {row.cluster.jobStartingDate &&
                            row.cluster.jobCompletionDate
                              ? `${dayjs(row.cluster.jobStartingDate).format(
                                  "DD/MM/YYYY"
                                )} - ${dayjs(
                                  row.cluster.jobCompletionDate
                                ).format("DD/MM/YYYY")}`
                              : "N/A"}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            ₹ {row.paymentAmount || "N/A"}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            ₹ {row.totalAdvancePaidAmount || "N/A"}
                          </p>
                        </TableCell>
                        <TableCell>
                          <p className="text-[12px]">
                            ₹ {row.balanceAmount || "N/A"}
                          </p>
                        </TableCell>

                        {/* <TableCell className="flex justify-start items-center">
                          <Chip
                            label={row.pdiStatus || "N/A"}
                            sx={{
                              backgroundColor:
                                row?.pdiStatus === "Pending"
                                  ? "var(--yellow-bgChip-color)" 
                                  : row?.pdiStatus === "Done"
                                  ? "var(--green-bgChip-color)"
                                  : "var(--para-color)", 
                              color:
                                row?.pdiStatus === "Pending"
                                  ? "var(--textChip-yellow-color)"
                                  : "var(--textChip-green-color)", 
                              fontWeight: "bold",
                            }}
                          />
                        </TableCell> */}
                        <TableCell>
                          <Chip
                            label={row.PaymentStatus || "N/A"}
                            sx={{
                              backgroundColor:
                                row?.PaymentStatus === "Pending"
                                  ? "var(--yellow-bgChip-color)" // Light yellow background similar to bg-yellow-100
                                  : row?.PaymentStatus === "Paid"
                                  ? "var(--green-bgChip-color)"
                                  : "var(--para-color)", // Default color for other statuses
                              color:
                                row?.PaymentStatus === "Pending"
                                  ? "var(--textChip-yellow-color)" // Text color similar to text-yellow-500
                                  : "var(--textChip-green-color)",
                              fontWeight: "bold",
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <div className="flex justify-center items-center h-96 w-full">
                        No Payments found
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      </Grid>
    </Dialog>
  );
};

export default VendorPaymentsModal;
